import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import moment from "moment";
import { Grid, Header, Table } from "semantic-ui-react";
import { daysOfWeek } from "../../constants/general";
import { spliteByWeeks } from "../../helpers/dateHelpers";
import { RawHTML, LineBreaks } from "../common";
import Amenities from "../../components/common/Amenities";
import PriceDisplay from "../../containers/PriceDisplay";
import styles from "./styles.less";

class RoomDetailsAndAmenities extends Component {
  renderCancellationPolicy = () => {
    const { room, titles, ShowCancellationPolicy } = this.props;
    const cancellationPolicy = `* ${titles.CancellationPolicy}: ${
      room.rate.cancellationPolicyDescription
    }`;
    if (ShowCancellationPolicy) {
      return <p className={styles.cancellationPolicy}>{cancellationPolicy}</p>;
    } else return <div />;
  };

  render() {
    const { room, isRtl, titles } = this.props;
    const textAlign = isRtl ? "right" : "left";
    const weeksData = spliteByWeeks(
      room && room.rate && room.rate.pricePerDayList
    );
    return (
      <Grid
        textAlign={textAlign}
        className={cx(styles.roomDetails, { [styles.rtl]: isRtl })}
      >
        <Grid.Column width={16}>
          <Header
            inverted
            as="h3"
            content={room.name}
            className={styles.roomName}
          />
          <LineBreaks>
            <Amenities
              amenities={room.amenities}
              isRtl={isRtl}
              includeName={true}
              isntPreview={true}
            />
          </LineBreaks>
          <LineBreaks>
            <RawHTML
              html={room.roomDescription}
              className={styles.roomDescription}
            />
          </LineBreaks>
          <LineBreaks>
            <RawHTML html={room.planName} className={styles.planName} />
          </LineBreaks>
          <LineBreaks>
            <Grid.Column width={16}>
              <Table
                className={styles.table}
                definition
                celled
                compact
                size="small"
                striped
                unstackable
                structured
                textAlign="center"
              >
                <Table.Header fullWidth>
                  <Table.Row>
                    <Table.HeaderCell icon="calendar" />
                    {daysOfWeek.map((day, idx) => (
                      <Table.HeaderCell key={idx}>
                        {titles[day.longKey] || day.name}
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {weeksData &&
                    Object.entries(weeksData).map(([week, priceList], idx) => {
                      const currentWeekNum = Number(week);
                      let contentIndex = `${titles.Week} ${idx + 1}`;
                      return (
                        <Table.Row key={idx}>
                          <Table.Cell content={contentIndex} />
                          {daysOfWeek.map((day, i) => {
                            const foundPrice = priceList.find(
                              ppd =>
                                moment(ppd.dayDate).day() === i &&
                                moment(ppd.dayDate).week() === currentWeekNum
                            );
                            const content = foundPrice && (
                              <PriceDisplay
                                price={foundPrice.dayFinalPrice}
                                currentCurrencyCode={room.currencyCode}
                                fallBackCurrencySymbol={room.currency}
                              >
                                {convertedPrice => convertedPrice}
                              </PriceDisplay>
                            );
                            const toRender = foundPrice && (
                              <React.Fragment>
                                <div className={styles.dayPrice}>{content}</div>
                                <small className={styles.dayDate}>
                                  {moment(foundPrice.dayDate).format(
                                    "DD/MM/YY"
                                  )}
                                </small>
                              </React.Fragment>
                            );
                            return (
                              <Table.Cell
                                key={i}
                                active={!!content}
                                content={toRender}
                              />
                            );
                          })}
                        </Table.Row>
                      );
                    })}
                </Table.Body>
                <Table.Footer fullWidth>
                  <Table.Row>
                    <Table.HeaderCell colSpan={8} textAlign={"left"}>
                      <Header>
                        <PriceDisplay
                          price={room.totalPrice}
                          currentCurrencyCode={room.currencyCode}
                          fallBackCurrencySymbol={room.currency}
                        >
                          {convertedPrice =>
                            `${titles.Total} - ${convertedPrice}`
                          }
                        </PriceDisplay>
                      </Header>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </Grid.Column>
            <Grid.Column width={16}>
              <p className={styles.taxIncludedTitle}>
                {titles.TaxIncludedTitle}
              </p>
            </Grid.Column>
          </LineBreaks>
          <LineBreaks>
            <Grid.Column width={16}>
              {this.renderCancellationPolicy()}
            </Grid.Column>
          </LineBreaks>
        </Grid.Column>
      </Grid>
    );
  }
}

RoomDetailsAndAmenities.propTypes = {
  room: PropTypes.object,
  isRtl: PropTypes.bool,
  ShowCancellationPolicy: PropTypes.bool,
  titles: PropTypes.object
};

export default RoomDetailsAndAmenities;



// WEBPACK FOOTER //
// ./src/components/RoomDetailsAndAmenities/RoomDetailsAndAmenities.js